export const truncateToTwoDecimals = (value: string | number | null | undefined): string => {
    if (value === null || value === undefined || value === "") return "N/A";

    const str = String(value);
    const num = Number(str);
    if (isNaN(num)) return "N/A";

    const [intPart, decPart = ""] = str.split(".");
    return `${intPart}.${(decPart + "00").slice(0, 2)}`;
};
